import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';

const Confirmed = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  let learning = params.get('learning') === 'true' ? 'Learning' : '';
  let summary = params.get('summary') === 'true' ? 'Weekly Summary' : '';
  let joining =
    params.get('learning') === 'true' && params.get('summary') === 'true'
      ? 'or'
      : '';

  const selectedUpdates = `${learning} ${joining} ${summary}`;
  return (
    <div className="unsubscribe">
      <div className="unsubscribe__box">
        <div
          className="icon"
          style={{
            textAlign: 'center',
            marginLeft: '-30px',
            marginBottom: '50px',
          }}
        >
          <span className={'fa-layers fa-fw'}>
            <FontAwesomeIcon
              icon={faCircle}
              style={{ color: 'rgb(165 237 209)' }}
              size={'4x'}
            />
            <FontAwesomeIcon
              icon={faCheck}
              style={{ color: 'green' }}
              size={'4x'}
              transform={`shrink-10`}
            />
          </span>
        </div>
        <h1>Thank you</h1>
        <p>
          You will no longer receive {selectedUpdates} updates. You may continue
          to receive other emails such as our newsletter.
        </p>
        <p>
          You can opt out of other communications by clicking on the unsubscribe
          link at the bottom of those emails.
        </p>
      </div>
    </div>
  );
};

export default Confirmed;
